import {err, ok} from 'framework';
import type {Result} from 'framework';
import type {KeyValueStoragePort} from '@/shared/application/ports/key-value-storage.port';

/**
 * `localStorage`-backed implementation of {@link KeyValueStoragePort}.
 * Wraps every call in a `Result` so quota errors, disabled storage
 * (Safari private mode), or SSR boots never crash the caller.
 */
export class LocalStorageAdapter implements KeyValueStoragePort {
  async get(key: string): Promise<Result<string | null>> {
    try {
      return ok(window.localStorage.getItem(key));
    } catch (cause) {
      return err(cause instanceof Error ? cause : new Error('localStorage.getItem failed.'));
    }
  }

  async set(key: string, value: string): Promise<Result<void>> {
    try {
      window.localStorage.setItem(key, value);
      return ok(undefined);
    } catch (cause) {
      return err(cause instanceof Error ? cause : new Error('localStorage.setItem failed.'));
    }
  }

  async remove(key: string): Promise<Result<void>> {
    try {
      window.localStorage.removeItem(key);
      return ok(undefined);
    } catch (cause) {
      return err(cause instanceof Error ? cause : new Error('localStorage.removeItem failed.'));
    }
  }
}
